import './Menu.scss';
import { useContext, useEffect, useState } from 'react';
import { AgentModeContext } from '../context/AgentModeContext';
import {
  BefGlobalContext,
  BefMenuServiceContext,
  BefMessage,
  BefMessageServiceContext,
  BefPage,
  BefPageContainer,
  BefPageControllerContext,
  IBefMenu,
  IBefMenuElement,
} from '@beflam/bef-core';
import menuRefresh from './menuRefresh';
import { createComponentPage } from '../lib/renderSchemaHelper';
import { TabManager } from './tabManager';
import { MenuOverlay } from './MenuOverlay';
import { ColleagueOverlay } from './AiColleague/ColleagueOverlay';
import { AssistantOverlay } from './AiAssistant/AssistantOverlay';
declare var $: any;

export function Menu(prop: any) {
  const [menuData, setMenuData] = useState<IBefMenu[] | null>(null);
  const [datasetMenuVisible, setDatasetMenuVisible] = useState<boolean>(false);
  //获取Menu上下文服务
  const menu = useContext(BefMenuServiceContext);
  const pageController = useContext(BefPageControllerContext);
  // let sConfig = useContext(BefConfigContext);
  let sGlobal = useContext(BefGlobalContext);
  const sMessageController = useContext(BefMessageServiceContext);

  // 创建 TabManager 实例
  const tabManager = new TabManager(pageController);
  const agentModeCtx = useContext(AgentModeContext);

  menuRefresh.removeAllListeners();
  menuRefresh.on('refreshMenu', (val) => {
    if (val && val.isRefresh) {
      // console.log(123);
      setMenuData(val.data);
      afterGetData();
    }
  });
  const [isReady, setIsReady] = useState<boolean>(false);
  const NavToggle = () => {
    $('.navbar-minimalize').trigger('click');
  };
  useEffect(() => {
    //固定菜单栏
    $('.sidebar-collapse').slimScroll({
      height: 'auto',
      width: '100%',
      position: 'right',
      size: '7px',
      color: '#ccc',
      wheelStep: 10,
      touchScrollStep: 100,
    });
    $('.nav-close').click(NavToggle);

    const initEventSub = prop.initEvent.subscribe(async (initResult: any) => {
      // if (
      //   initResult &&
      //   initResult.Permission &&
      //   initResult.Permission.BEF_SYS_ADMIN &&
      //   initResult.Permission.BEF_SYS_ADMIN.includes('User')
      // ) {
      //   setDatasetMenuVisible(true);
      // } else {
      //   setDatasetMenuVisible(false);
      // }
      
      setDatasetMenuVisible(true); //目前知识库都可见
      menu.getMenuGroups().subscribe(
        (result) => {
          setMenuData(result);
          afterGetData();
          setIsReady(true);
          prop.contentInitEvent?.next(initResult);
        },
        (error) => {
          sMessageController.showMessage(
            BefMessage.createFromError(error, 'sysError')
          );
          prop.contentInitEvent?.next(initResult);
        }
      );
    });

    //打开页面时添加tab
    const afterPageShowSub = sGlobal.afterPageShow.subscribe(() => {
      menuItem();
    });
    return () => {
      initEventSub.unsubscribe();
      afterPageShowSub.unsubscribe();
    };
  }, []);

  const afterGetData = () => {
    // 菜单点击事件
    var sidebarMenuClick = function (e: MouseEvent) {
      if ($(e.currentTarget).parent().hasClass('bef-submenu')) {
        e.preventDefault();
      }
      if (!$(e.currentTarget).hasClass('bef-subdrop')) {
        $('ul', $(e.currentTarget).parents('ul:first')).slideUp(250);
        $('a', $(e.currentTarget).parents('ul:first')).removeClass(
          'bef-subdrop'
        );
        $(e.currentTarget).next('ul').slideDown(350);
        $(e.currentTarget).addClass('bef-subdrop');
      } else if ($(e.currentTarget).hasClass('bef-subdrop')) {
        $(e.currentTarget).removeClass('bef-subdrop');
        $(e.currentTarget).next('ul').slideUp(350);
      }
    };
    $('.bef-sidebar-menu a').off('click.sidebarMenuClick');
    $('.bef-sidebar-menu a').on('click.sidebarMenuClick', sidebarMenuClick);

    function addTab() {
      return true;
    }
    $('.J_menuItem').off('click.addTab');
    $('.J_menuItem').on('click.addTab', addTab);

    // 绑定 TabManager 的事件处理器
    tabManager.bindEventHandlers();
  };

  //点击菜单
  const onMenuItemClick = (_menu: IBefMenuElement, _moduleId?: string) => {
    sGlobal.aiVisibleEvent.emit({ visible: false });
    menu.openMenu(_menu, _moduleId);
    // if (pageController.activeContainer?.activePage?.state == "test") {
    //   pageController.show(new BefPage('demo', 'demo', 'demo'));

    // }
    // else {
    //   pageController.show(new BefPage('demo', 'demo', 'test'));

    // }
  };

  //动态设置tab
  const menuItem = () => {
    var activContainer: BefPageContainer = new BefPageContainer();
    pageController.pageContainers.forEach((container: BefPageContainer) => {
      if (container.isActive) activContainer = container;
    });
    // 获取标识数据
    var dataUrl = activContainer.id,
      menuName = activContainer.title,
      flag = true;
    if (dataUrl === undefined || $.trim(dataUrl).length === 0) return false;

    // 选项卡菜单已存在
    $('.J_menuTab').each(function (index: any, tab: any) {
      if ($(tab).data('id') === dataUrl) {
        if (!$(tab).hasClass('active')) {
          $(tab)
            .addClass('active')
            .siblings('.J_menuTab')
            .removeClass('active');
          tabManager.scrollToTab($(tab));
        }
        flag = false;
        return false;
      }
    });

    // 选项卡菜单不存在
    if (flag) {
      //TO-DO
      //目前menuName是获取的BefPageContainer.title，title的实际取Page的标题是需要在rpc后才能拿到的，rpc前拿的是State的名称（当然也可以在showPage的时候指定Title）
      //由于Tab显示比比BefPage显示早，所以目前这里的menuName都显示的是Page的State。
      var str =
        '<a href="javascript:;" class="active J_menuTab" data-id="' +
        activContainer.id +
        '">' +
        menuName +
        ' <i class="fa fa-times-circle"></i></a>';
      $('.J_menuTab').removeClass('active');
      // 添加选项卡
      $('.J_menuTabs .page-tabs-content').append(str);
      tabManager.scrollToTab($('.J_menuTab.active'));
    }
    if (
      $('.J_menuTabs .page-tabs-content .J_menuTab.active') &&
      $('.J_menuTabs .page-tabs-content .J_menuTab.active').length > 0 &&
      $('.J_menuTabs .page-tabs-content .J_menuTab.active')[0].childNodes
        .length > 0
    )
      $(
        '.J_menuTabs .page-tabs-content .J_menuTab.active'
      )[0].childNodes[0].data = menuName + ' ';
    return false;
  };

  const If = (props: { condition: boolean; then: any; else: any }) => {
    const condition = props.condition || false;
    const positive = props.then || null;
    const negative = props.else || null;

    return condition ? positive : negative;
  };

  const getIconControl = (icon: string) => {
    if (icon) {
      if (icon.split('/').length > 1) {
        return (
          <img
            alt="image"
            src={icon}
            style={{
              marginRight: '6px',
              maxWidth: '13px',
              maxHeight: '13px',
              float: 'left',
            }}
          />
        );
      } else {
        return (
          <i
            className={icon}
            aria-hidden="true"
            style={{ marginRight: '6px' }}
          ></i>
        );
      }
    }
    return null;
  };

  const starMenu = async (item: IBefMenuElement, event?: any) => {
    event?.stopPropagation();
    var result = await menu.starMenu(item.ID, !item.IsStarred);
    setMenuData(result);
    afterGetData();
  };
  const getStarIcon = (item: IBefMenuElement) => {
    if (item && !item.IsStarMenu)
      return (
        <span
          className={
            'arrow glyphicon ' +
            (item.IsStarred
              ? 'glyphicon-star bef-menu-star-active'
              : 'glyphicon-star-empty')
          }
          onClick={starMenu.bind(null, item)}
        ></span>
      );
    else return null;
  };

  const openNativePage = (componentName: string, title: string) => {
    sGlobal.aiVisibleEvent.emit({ visible: false });
    let page = createComponentPage(componentName);
    pageController.show(page, title);
  };

  const openAllFunctions = () => {
    openNativePage('BefAllFunction', '所有功能');
  };

  const getMenuItemTem = (
    item: IBefMenuElement,
    parentKey: string,
    level: number
  ) => {
    const key = `${parentKey}-menu-${item.ID}`;
    const marginLeft = level > 2 ? (level - 2) * 30 : 0;
    return (
      <li
        key={key}
        className={
          (item.Items?.length ?? 0) > 0
            ? `bef-submenu bef-submenu-${level} bef-inside-submenu`
            : `bef-submenu-${level}`
        }
      >
        <a
          className={(item.Items?.length ?? 0) > 0 ? '' : 'J_menuItem'}
          style={{
            marginLeft: marginLeft,
            width: `calc(100% - ${marginLeft}px)`,
          }}
          onClick={() => {
            onMenuItemClick(item);
          }}
        >
          <span className="bef-submenu-label">{item.Text}</span>
          <If
            condition={(item.Items?.length ?? 0) > 0}
            then={<span className="bef-menu-arrow" />}
            else={getStarIcon(item)}
          ></If>
        </a>
        <If
          condition={(item.Items?.length ?? 0) > 0}
          then={
            <ul>
              {item.Items?.map((item2: IBefMenuElement) =>
                getMenuItemTem(item2, key, level + 1)
              )}
            </ul>
          }
          else={null}
        />
      </li>
    );
  };
  const openAIPage = (type: string = '', colleague: any = {}) => {
    tabManager.tabCloseAll();
    agentModeCtx.openAIPage(type, colleague);
  };

  const openDataSets = () => {
    openNativePage('BefFileManager', '文档管理');
  };

  const openIssue = () => {
    openNativePage('MyIssueList', '议题');
  };

  const handleAIColleagueOK = (colleague: any) => {
    openAIPage('AIUSER', colleague);
  };
  const handleAIAssistantOK = (assistant: any) => {
    openAIPage('', assistant);
  };

  return (
    <>
      <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="nav-close">
          <i className="fa fa-times-circle"></i>
        </div>
        <div className="sidebar-collapse">
          <div className="bef-sidebar-menu">
            {isReady && (
              <ul>
                <li key="system">
                  <h6 className="bef-submenu-hdr">系统管理</h6>
                  <ul>
                    {sGlobal.agent?.AIAgent && (
                      <li key="bef-assistant" className="bef-submenu">
                        <AssistantOverlay
                          onOk={handleAIAssistantOK}
                        ></AssistantOverlay>
                      </li>
                    )}
                    {sGlobal.agent?.AIColleague && (
                      <li key="bef-colleague" className="bef-submenu">
                        <ColleagueOverlay
                          onOk={handleAIColleagueOK}
                        ></ColleagueOverlay>
                      </li>
                    )}
                    {sGlobal.agent?.AIAgent && (<li key="bef-ai" className="bef-submenu">
                      <a
                        className="J_menuItem"
                        onClick={() => openAIPage('RESEARCH')}
                      >
                        <i className="bef-ai-i">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                          >
                            <path
                              d="M9 5 a 3 3 0 1 0 -6 0 a 3 3 0 1 0 6 0 M9 5 a 2 2 0 1 0 -4 0 a 2 2 0 1 0 4 0 M9 5 a 1 1 0 1 0 -2 0 a 1 1 0 1 0 2 0 M10.2 6.2 L13.6 9.6 M2 11 h8 M2 12.6 h8 M2 14.2 h8"
                              stroke="#000"
                              stroke-width="1.1"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </i>
                        <span className="bef-menu-label">深度研究</span>
                      </a>
                    </li>)}
                    <li key="bef-issue" className="bef-submenu">
                      <a className="J_menuItem" onClick={() => openIssue()}>
                        <i
                          className="glyphicon glyphicon-list-alt"
                          aria-hidden="true"
                        />
                        <span className="bef-menu-label">议题</span>
                      </a>
                    </li>
                    {datasetMenuVisible && (
                      <li key="bef-favoritechat" className="bef-submenu">
                        <a
                          className="J_menuItem"
                          onClick={() => {
                            openDataSets();
                          }}
                        >
                          <i
                            className="glyphicon glyphicon-book"
                            aria-hidden="true"
                          />
                          <span className="bef-menu-label">文档管理</span>
                        </a>
                      </li>
                    )}
                    <li key="bef-allfunctions" className="bef-submenu">
                      <MenuOverlay data={menuData}></MenuOverlay>
                    </li>
                  </ul>
                </li>
                {menuData?.map((menu) => {
                  return menu?.Groups?.filter(
                    (it) => it.ID === '__starMenuGroup'
                  ).map((group) => {
                    let key = `${menu.Id}-group-${group.ID}`;
                    return (
                      <li key={key}>
                        <h6 className="bef-submenu-hdr">{group.Text}</h6>
                        <If
                          condition={(group.Items?.length ?? 0) > 0}
                          then={
                            <ul>
                              {group.Items?.map((item) => {
                                key += `-menu-${item.ID}`;
                                return (
                                  <li
                                    key={key}
                                    className={
                                      (item.Items?.length ?? 0) > 0
                                        ? 'bef-submenu'
                                        : ''
                                    }
                                  >
                                    <a
                                      className={
                                        (item.Items?.length ?? 0) > 0
                                          ? ''
                                          : 'J_menuItem'
                                      }
                                      onClick={() => {
                                        onMenuItemClick(item);
                                      }}
                                    >
                                      <If
                                        condition={!item.Icon}
                                        then={
                                          <i className="glyphicon glyphicon-th-large" />
                                        }
                                        else={getIconControl(item.Icon)}
                                      ></If>
                                      <span className="bef-menu-label">
                                        {item.Text}
                                      </span>
                                      <If
                                        condition={
                                          (item.Items?.length ?? 0) > 0
                                        }
                                        then={
                                          <span className="bef-menu-arrow" />
                                        }
                                        else={getStarIcon(item)}
                                      />
                                    </a>
                                    <If
                                      condition={(item.Items?.length ?? 0) > 0}
                                      then={
                                        <ul>
                                          {item.Items?.map(
                                            (item2: IBefMenuElement) =>
                                              getMenuItemTem(item2, key, 2)
                                          )}
                                        </ul>
                                      }
                                      else={null}
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          }
                          else={null}
                        />
                      </li>
                    );
                  });
                })}
              </ul>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}